import React from "react";
import PropTypes from "prop-types";
import SFCard, { SFCardBody } from "./index";
import { SFGridContainer, SFGridItem, SFStack } from "../grid";
import SFTypography from "../typography";
import SFSkeleton from "../skeleton";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const SFCardStyled = styled(SFCard)(() => ({
  padding: "25px 30px",
}));

const SFCardBodyStyled = styled(SFCardBody)(({ theme }) => ({
  padding: "0px !important",
}));

const SFBreakdownCardHeader = ({ icon, label, count }) => {
  return (
    <SFStack direction="row" alignItems="center" justifyContent="space-between">
      <SFStack direction="row" alignItems="center" spacing={1.25}>
        {icon}
        <SFTypography variant="body1bold">{label}</SFTypography>
      </SFStack>
      <SFTypography variant="cardNumberLarge">{count}</SFTypography>
    </SFStack>
  );
};

const SFBreakdownCardContent = ({ details }) => {
  return (
    <SFStack spacing={0.5}>
      {details.map((obj, index) => (
        <SFStack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          key={index}
        >
          <SFTypography variant="body1">{obj.data.label}</SFTypography>
          <SFTypography variant="cardNumber">{obj.data.count}</SFTypography>
        </SFStack>
      ))}
    </SFStack>
  );
};

const SFBreakdownCard = ({ icon, header, details, loading = false }) => {
  if (loading) {
    return <SFSkeleton rows={4} />;
  }

  return (
    <SFCardStyled>
      <SFCardBodyStyled>
        <SFGridContainer spacing={1.5}>
          <SFGridItem xs>
            <SFStack spacing={2.5}>
              <SFBreakdownCardHeader
                icon={icon}
                label={header?.data?.label}
                count={header.data?.count}
              />
              <SFBreakdownCardContent details={details} />
            </SFStack>
          </SFGridItem>
        </SFGridContainer>
      </SFCardBodyStyled>
    </SFCardStyled>
  );
};

SFBreakdownCard.propTypes = {
  /**
   * The icon to be displayed on the left
   */
  icon: PropTypes.node.isRequired,
  /**
   * The header is an object with a nested object as data property with the label and count property ( e.g. { data: { label:"label 1" , count : 1 } } ),
   */
  header: PropTypes.shape({
    data: PropTypes.shape({
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
    }),
  }),
  /**
   *  An array of labels to be rendered below the header. An array of objects with a nested object as data property with the label and count properties
   * ( e.g. [ { data: { label:"label 1" , count : 1 } }, { data: { label:"label 2" , count : 2 } }] )
   */
  details: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.shape({
        label: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
      }),
    })
  ),
  loading: PropTypes.bool,
};
export default SFBreakdownCard;
